module.exports = __webpack_public_path__ + "img/superlever-bgNumer1.9870aece.svg";